<div class="tab-control">
    <div *ngFor="let tab of tabs" class="tab" (click)="selectTab(tab)" [class.active]="tab.active">
        <span>
            <i class="tab-icon {{tab.icon}}"></i> {{tab.title}}
        </span>
    </div>
</div>

<ng-content>
</ng-content>